import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "grid grid--quiz" }
const _hoisted_5 = { class: "reset center" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "column" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "column" }

import { Quiz } from '@/models/Quiz';
import QuizTileComponent from '@/components/QuizTileComponent.vue';
import EmailComponent from '@/components/EmailComponent.vue';
import NewsletterComponent from '@/components/NewsletterComponent.vue';
import DataPrivacyOverlayComponent from '@/components/DataPrivacyOverlayComponent.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeComponent',
  props: {
    quizzes: {},
    overlayIsVisible: { type: Boolean },
    hasProgress: { type: Boolean }
  },
  emits: ["reset", "setIsLoading", "toggleOverlay", "setQuiz"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const setQuiz = (id: string) => {
  emit('setQuiz', id);
};

const reset = () => {
  emit('reset');
};

const setIsLoading = (event: boolean) => {
  emit('setIsLoading', event);
};

const onToggleOverlay = (event: boolean) => {
  emit('toggleOverlay', event);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "center" }, "Überprüfe dein Wissen mit einem Quiz", -1)),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.quizzes, (quiz) => {
            return (_openBlock(), _createBlock(QuizTileComponent, {
              key: quiz.id,
              onSetQuiz: _cache[0] || (_cache[0] = ($event: any) => (setQuiz($event))),
              quiz: quiz
            }, null, 8, ["quiz"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (reset())),
            disabled: _ctx.hasProgress === false
          }, " Fortschritt zurücksetzen ", 8, _hoisted_6)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(NewsletterComponent)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(EmailComponent, {
          overlayIsVisible: props.overlayIsVisible,
          onSetIsLoading: _cache[2] || (_cache[2] = ($event: any) => (setIsLoading($event))),
          onToggleOverlay: _cache[3] || (_cache[3] = ($event: any) => (onToggleOverlay($event)))
        }, null, 8, ["overlayIsVisible"])
      ])
    ]),
    (props.overlayIsVisible)
      ? (_openBlock(), _createBlock(DataPrivacyOverlayComponent, {
          key: 0,
          onToggleOverlay: _cache[4] || (_cache[4] = ($event: any) => (onToggleOverlay($event)))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})